export function truncateText(text: string, maxLength: number = 15) {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
}
